import React, { Fragment, useState } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button } from "components"
import SmptPosList from "./SmptPosList"
import SmptPcPosModal from "./SmptPcPosModal"
import classes from "./index.module.scss"

const SettingsMyPosTerminals = () => {
  const [t, i18n] = useTranslation()

  const [openPcPosModal, setOpenPcPosModal] = useState(false)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div
        className={clsx(
          classes["container"],
          isLtr && classes["container-ltr"]
        )}
      >
        <Button
          color="success"
          className={classes["button"]}
          onClick={() => setOpenPcPosModal(true)}
        >
          {t("افزودن_کارت_خوان")}
        </Button>

        <SmptPosList />
      </div>

      <SmptPcPosModal
        openPcPosModal={openPcPosModal}
        setOpenPcPosModal={setOpenPcPosModal}
      />
    </Fragment>
  )
}

export default SettingsMyPosTerminals